<app-page headline="Device Care Centers">
  <DataTable
    [datasource]="deviceCareCenter"
    [columns]="deviceCareCenterColumns"
    (rowClick)="handleRowClick($event)"
  >
    <div
      row-layout
      paddingLeft="md"
      ngProjectAs="data-table-header"
      justifyContent="space-between"
      alignItems="center"
    >
      <Text role="headline-medium" color="on-background-variant"
        >Care Center Locations</Text
      >

      <app-download-button
        label="Download Device Care Centers (xlsx)"
        [blobObservable]="deviceCareCenterService.downloadDeviceCareCenters()"
        downloadFileName="ATB_Device_Care_Centers"
      />
    </div>
  </DataTable>
</app-page>

<Dialog [show]="showDialog()" (showing)="showDialog.set($event)">
  <DialogHeader>Details</DialogHeader>
  <div box-layout padding="sm" paddingLeft="md">
    @if (selectedDeviceCareCenter(); as dcc) {
      <div grid-layout templateColumns="1fr 1fr" gap="md">
        <div stack-layout paddingTop="sm" gap="sm">
          <app-display-value label="Code">
            {{ dcc.code }}
          </app-display-value>

          <app-display-value label="Name">
            {{ dcc.name }}
          </app-display-value>

          <app-display-value label="Order Consolidation time (UTC)">
            {{ dcc.orderConsolidationTimeUtc || '' }}
          </app-display-value>
        </div>

        <div
          stack-layout
          color="secondary-surface"
          borderRadius="xs"
          paddingHorizontal="md"
          paddingVertical="sm"
          gap="sm"
          [minWidth]="200"
        >
          <Text
            role="headline-small"
            color="on-primary-surface-variant"
            [nowrap]="true"
          >
            Address
          </Text>

          <Text>{{ dcc.address1 }}</Text>
          <Text>{{ dcc.address2 }}</Text>

          <Text>
            {{ dcc.city }},
            {{ dcc.state }}
            {{ dcc.postalCode }}
          </Text>

          <Text>
            {{ dcc.county }}
          </Text>

          <Text>
            {{ dcc.country }}
          </Text>
        </div>
      </div>
    }
  </div>
</Dialog>
